import LinkedCompaniesTable from "./LinkedCompaniesTable";

const LinkedCompanies = () => {
  return (
    <div>
      <LinkedCompaniesTable />
    </div>
  );
};

export default LinkedCompanies;
